import {useMemo} from 'react';

export default function useBrowser() {

	const browserDetails = useMemo(() => {
		const browserData = {
			firefox: {
				isFirefox: true,
				icon: require('../public/assets/images/browsers/mozilla.png'),
				name: 'Mozilla Firefox'
			},
			chrome: {
				isChrome: true,
				icon: require('../public/assets/images/browsers/chrome.png'),
				name: 'Google Chrome'
			},
			edge: {
				isEdge: true,
				icon: require('../public/assets/images/browsers/edge.png'),
				name: 'Microsoft Edge'
			},
			safari: {
				isSafari: true,
				icon: require('../public/assets/images/browsers/safari.png'),
				name: 'Safari'
			},
			opera: {
				isOpera: true,
				icon: require('../public/assets/images/browsers/opera.png'),
				name: 'Opera'
			},
			default: {
				isDefault: true,
				icon: require('../public/assets/images/browsers/global.png'),
				name: 'Browser'
			}
		}

		if (typeof window.chrome !== 'undefined' && window.navigator.userAgent.indexOf("Edg") !== -1) return browserData.edge
		if (typeof window.chrome !== 'undefined') return browserData.chrome
		if (typeof window.InstallTrigger !== 'undefined') return browserData.firefox
		if (typeof window.safari !== 'undefined' && !window.chrome && window.navigator.vendor.indexOf("Apple") !== -1) return browserData.safari
		if (typeof window.opr !== 'undefined' || typeof window.opera !== 'undefined') return browserData.opera


		// const isFirefox = window.navigator.userAgent.includes('Firefox/');
		// if(isFirefox) return browserData.firefox;
		//
		//
		// const agentData = window.navigator.userAgentData;
		// if(agentData && agentData.brands && agentData.brands[agentData.brands.length - 1]) {
		// 	if(agentData.brands[agentData.brands.length - 1].brand === 'Google Chrome') return browserData.chrome;
		// 	if(agentData.brands[agentData.brands.length - 1].brand === 'Microsoft Edge') return browserData.edge;
		// }
		//
		// if(window.navigator.vendor.includes('Apple Computer') && window.navigator.userAgent.includes('Safari/')) return browserData.safari;
		//
		return browserData.default;
	}, []);

	return {browserDetails};
}
